<ng-container *ngIf="mode == 'ReadOnly'; then read; else edit"></ng-container>
<ng-template #read>

    <span class='company-picker-item' *ngIf="control?.value; else emptyField">
        <!-- <profile class="info margin-right-5" [userId]="control?.value?._id" [userName]="control?.value?.name"> </profile> -->
        <span class='user-name'>{{control?.value?.name}}</span>
    </span>

</ng-template>
<ng-template #edit>
    <ng-select [readonly]="readonly" [items]="data" [appendTo]="appendTo" bindLabel="name" [placeholder]="placeholder" [hideSelected]="true" [compareWith]="compareFn" [searchFn]="searchFn" [multiple]="multiple" [searchable]="true" [formControl]="control">
        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            <div class="ng-value" *ngFor="let item of items">
                <contact-item-picker (clear)="clear(item)" [clearTemplate]="true" [entity]="item"></contact-item-picker>
            </div>
        </ng-template>
        <ng-template ng-label-tmp let-item="item" let-index="index">
            <contact-item-picker [clearTemplate]="true" [entity]="item"></contact-item-picker>
        </ng-template>
        <ng-template ng-option-tmp let-item="item" let-index="index">
            <contact-item-picker [entity]="item"></contact-item-picker>
        </ng-template>
    </ng-select>

</ng-template>


<ng-template #emptyField>
    <span class="empty-field">{{ emptyText }}</span>
</ng-template>